module.exports = __webpack_public_path__ + "media/bell-notification.wav";